function Footer() {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <p>Made by Harshad Marathe</p>
    </div>
  );
}

export default Footer;
